import { PrimaryHoverEffectBox } from "src/components/ui/warehouse/primaryHoverEffect/style";

const PrimaryHoverEffect = (props) => {
  const { children, heighteffect, ...rest } = props;

  return (
    <PrimaryHoverEffectBox heighteffect={heighteffect} {...rest}>
      {children}
    </PrimaryHoverEffectBox>
  );
};

export default PrimaryHoverEffect;
